var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 113,
    viewBox: "0 0 108 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"celebrate cake wedding\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5927 31.8398C76.5927 50.0438 65.5244 68.9195 51.8729 68.9195C38.2214 68.9195 27.1531 50.0438 27.1531 31.8398C27.1531 13.6357 38.2214 3 51.8729 3C65.5244 3 76.5927 13.6357 76.5927 31.8398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.153 31.8401C27.153 21.7606 30.5561 14.0151 35.9017 9.09585L35.8997 9.06495C26.1642 5.01502 16.3525 7.1368 9.45155 14.0357C-0.201535 23.6929 -0.506413 39.0377 12.3644 51.9085C20.594 60.1381 32.2164 65.3622 42.0508 65.5394L42.0487 65.5291C33.2876 59.2915 27.153 45.3866 27.153 31.8401Z",
    fill: "#A0DCF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4135 14.0367C90.8513 6.47453 79.7934 4.64938 69.1721 10.4029L69.17 10.4132C73.7452 15.3531 76.5921 22.6207 76.5921 31.8412C76.5921 45.2372 70.5873 58.9691 61.9807 65.3035L61.9766 65.3344C72.4804 66.7064 86.1711 61.2392 95.5007 51.9095C108.372 39.0387 108.069 23.6919 98.4135 14.0367Z",
    fill: "#4BAADC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1127 77.1594C60.1127 72.6089 56.4233 68.9194 51.8728 68.9194C47.3223 68.9194 43.6329 72.6089 43.6329 77.1594H60.1127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M51.8728 77.1592C51.8728 77.1592 43.6329 81.2791 43.6329 87.4591C43.6329 93.639 55.9928 96.9865 55.9928 101.879C55.9928 106.771 47.7528 110.119 47.7528 110.119",
    stroke: "#4BAADC",
    strokeWidth: 4.11997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5927 31.8398C76.5927 50.0438 65.5244 68.9195 51.8729 68.9195C38.2214 68.9195 27.1531 50.0438 27.1531 31.8398C27.1531 13.6357 38.2214 3 51.8729 3C65.5244 3 76.5927 13.6357 76.5927 31.8398Z",
    stroke: "#1E69A0",
    strokeWidth: 4.11997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M42.0507 65.5398C32.2163 65.3626 20.5939 60.1385 12.3642 51.9089C-0.506535 39.0381 -0.201657 23.6933 9.45142 14.0361C16.3524 7.13516 26.1641 5.01337 35.8995 9.06536",
    stroke: "#1E69A0",
    strokeWidth: 4.11997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M61.9766 65.3347C72.4804 66.7067 86.1711 61.2395 95.5007 51.9098C108.372 39.037 108.069 23.6901 98.4135 14.0391C90.8513 6.47485 79.7934 4.6497 69.1721 10.4012",
    stroke: "#1E69A0",
    strokeWidth: 4.11997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M35.3929 31.8396C35.3929 18.1881 42.7718 11.2397 51.8728 11.2397",
    stroke: "#4BAADC",
    strokeWidth: 4.11997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.9636 45.6202C8.45063 36.1072 8.74933 26.1225 15.092 19.7798",
    stroke: "#4BAADC",
    strokeWidth: 4.11997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1127 77.1594C60.1127 72.6089 56.4233 68.9194 51.8728 68.9194C47.3223 68.9194 43.6329 72.6089 43.6329 77.1594H60.1127Z",
    stroke: "#1E69A0",
    strokeWidth: 4.11997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrations);
export default __webpack_public_path__ + "static/media/celebrations.da7cedd0b0f81169434c877e81370b15.svg";
export { ForwardRef as ReactComponent };